import React from "react";
import { Button } from "@mui/material";
import { useProviderLanguage, PROVIDER_LANGUAGES } from "../i18n/ProviderLanguageContext";

// Renders nothing when the user's preference is English — there is no second
// language to switch to.
export default function LanguageToggle({ sx }) {
    const { lang, preferredLang, canToggle, toggleLang } = useProviderLanguage();

    if (!canToggle) return null;

    const preferred = PROVIDER_LANGUAGES.find((l) => l.code === preferredLang);
    const label = lang === "eng" ? preferred?.native || preferred?.name : "English";

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={toggleLang}
            sx={{
                textTransform: "none",
                borderRadius: 2,
                borderColor: "#0B2D6B",
                color: "#0B2D6B",
                fontWeight: 600,
                whiteSpace: "nowrap",
                "&:hover": { backgroundColor: "#0B2D6B", color: "#fff" },
                ...sx,
            }}
        >
            {label}
        </Button>
    );
}
